module.exports = __webpack_public_path__ + "static/img/Ajustados sin fondo_descargar.76b09c52.svg";